import { render } from "./NonBillingList.vue?vue&type=template&id=b6ffe224&scoped=true"
import script from "./NonBillingList.vue?vue&type=script&lang=js"
export * from "./NonBillingList.vue?vue&type=script&lang=js"

import "./NonBillingList.vue?vue&type=style&index=0&id=b6ffe224&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6ffe224"]])

export default __exports__